import dayjs from 'dayjs';
import APP_STATES from '../enums/AppStates';
import { rangePosition } from './dateUtils';

export const getProcessActualStage = (process) => {
  if (!process || !Array.isArray(process.etapas)) return {
    etapaActual: null
  };

  const orderedStages = [...process.etapas].sort((a, b) => a.orden - b.orden);

  const now = dayjs();
  let actualStage = orderedStages.find(e => e.activa);
  if (!actualStage) {
    actualStage = orderedStages.find(e =>
      dayjs(e.fechaInicio).isBefore(now) && dayjs(e.fechaCierre).isAfter(now)
    );
  }

  return actualStage || null;
};

export const getProcessDatePeriod = (process) => {
  if (!process || !Array.isArray(process.etapas)) return {
    startDate: null,
    endDate: null
  };

  const orderedStages = [...process.etapas].sort((a, b) => a.orden - b.orden);

  const startDate = orderedStages.length > 0 ? orderedStages[0].fechaInicio : null;
  const endDate = orderedStages.length > 0 ? orderedStages[orderedStages.length - 1].fechaCierre : null;

  return {
    startDate,
    endDate,
  };
};

export const isProcessActive = (process) => {
  if(!process) return false;

  const isActive = process.estado.Id.toUpperCase() === APP_STATES.ACTIVO;
  return isActive;
};

export const findStageById = (process, wanted) => {
  if (!process?.etapas?.length || !wanted) return null;
  const key = wanted?.toUpperCase();
  
  return process.etapas.find(e => e.idEtapa.toUpperCase() === key ) || null;
};

export const getStageWindow = (stage, now = new Date()) => {
  if (!stage) return { phase: 'none', inside: false };
  
  // Normalizar a solo fechas sin hora para comparación
  const nowDate = dayjs(now).startOf('day').toDate();
  const startDate = dayjs(stage.fechaInicio).startOf('day').toDate();
  const endDate = dayjs(stage.fechaCierre).startOf('day').toDate();
  
  const phase = rangePosition(startDate, endDate, nowDate);
  return { phase, inside: phase === 0 };
};